import React from 'react'
import {SequenceStages, LeadStatusConstants, TasksConstants} from '@exceed.ai/exceed-utils';

const {templateTypes} = SequenceStages;
const {leadStatusTypes, leadActionKeys} = LeadStatusConstants;
const {tasksActionsBySeqType} = TasksConstants;

// eslint-disable-next-line import/no-anonymous-default-export
export default ({senderPlatform, userItem, selectDifferentTemplate}) => {
    const isEmailTask = senderPlatform === "EMAIL";
    console.log(userItem.sequenceType)
    console.log(tasksActionsBySeqType[userItem.sequenceType])
    return <div className="exceed_page">
        {
            Object.entries(tasksActionsBySeqType[userItem.sequenceType]).map(([status, taskActions], groupIndex) => {
                const colorPrefix = "text-";
                let statusDisplayName = status;
                let statusColorClassName;

                switch (status) {
                    case leadStatusTypes.ASSIGNED_TO_REP: {
                        statusDisplayName = leadStatusTypes.ASSIGNED;
                        statusColorClassName = colorPrefix.concat(statusDisplayName);
                        break;
                    }
                    case "OTHER ACTIONS": {
                        statusColorClassName = "text-general";
                        break;
                    }
                    default: {
                        statusColorClassName = colorPrefix.concat(statusDisplayName);
                        break;
                    }
                }

                return (
                    <div key={`${statusDisplayName} - ${groupIndex}`}>
                        <span className={`overline-sm ${statusColorClassName.toLowerCase()}`}>
                                    {statusDisplayName}
                                </span>
                        {taskActions.map((taskAction) => {
                            if (!isEmailTask && !taskAction?.actionKey && !taskAction?.canBeTextMsg) {
                                return null;
                            }

                            if (taskAction?.actionKey === leadActionKeys.MARK_AS_WON) {
                                return null;
                            }

                            if (taskAction?.name === templateTypes.LOOP_BACK_IN.name &&
                                !(userItem?.leadInfo?.statusHistory?.some(x => x.leadStatus?.toUpperCase() === leadStatusTypes.ASSIGNED_TO_REP))) {
                                return null;
                            }

                            return (
                                <div
                                    className="p-1 pl-2"
                                    key={`${taskAction.name}`}
                                    onClick={() => selectDifferentTemplate(taskAction.name)}>
                                    {taskAction.displayName || taskAction.name}
                                </div>

                            );
                        })}
                    </div>
                );
            })
        }
    </div>
}